import {
    Features,
    useFeatureFlagValue,
} from '@experiences/feature-flags';
import { useLocalization } from '@experiences/locales';
import { UiText } from '@experiences/ui-common';
import CircularProgress from '@mui/material/CircularProgress';
import {
    makeStyles,
    useTheme,
} from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import React from 'react';
import { useIntl } from 'react-intl';

import { getPriceString } from '../helpers/EcommerceHelpers';

const useStyles = makeStyles(() =>
    createStyles({
        row: {
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
        },
        circularLoading: { borderRadius: '30px' },
    }),
);

export const EcommercePrice: React.FC<{
    value?: number;
    loading?: boolean;
    fontSize?: string;
    fontWeight?: number;
    fontColor?: string;
    gap?: boolean;
    currency: string;
    planType?: string;
    dataCy?: string;
}> = ({
    value,
    loading,
    fontSize,
    fontWeight,
    fontColor,
    gap,
    currency,
    planType,
    dataCy,
}) => {
    const classes = useStyles();
    const language = useLocalization();
    const theme = useTheme();
    const EnableEcommercePlanSelectionRevampM0 = useFeatureFlagValue(Features.EnableEcommercePlanSelectionRevampM0.name);

    const { formatMessage: translate } = useIntl();
    const style = {
        fontSize: fontSize ?? '14px',
        fontWeight,
        color: fontColor ? fontColor : theme.palette.semantic.colorForeground,
    };

    return (
        <div
            className={classes.row}
            data-cy={dataCy}>
            {(loading || !currency) ? (
                <CircularProgress
                    size={16}
                    className={classes.circularLoading} />
            ) : (
                <UiText style={style}>
                    {getPriceString(value!, currency, language)}
                </UiText>
            )}
            {!EnableEcommercePlanSelectionRevampM0 && planType && (
                <>
                    <UiText style={{
                        ...style,
                        margin: `0px ${gap ? '4px' : '0px'}`,
                    }}>
                /
                    </UiText>
                    <UiText style={style}>
                        {translate({ id: `CLIENT_PER_${planType.toUpperCase()}` })}
                    </UiText>
                </>
            )}
        </div>
    );
};
